/**
 * Vue Root Component
 * Product Selector Quote Form
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'ps-quote-form';
const log = debug(MODULE_NAME);


//
// Dependencies
const Vue = window.Vue;
import memoize from 'lodash/memoize';
import WordSelectorComponent from './word-selector';
import {WORD_SELECTOR_SELECTOR} from '../config';
import {extractAllWordSelectorValues} from '../functions';


//
// Constants
const HAS_VUE = 'has-vue';

/**
 * Factory for creating a QuoteForm root Vue component
 * @param {Element} context - Element to mount Vue on
 * @returns {Vue} Vue Root Object e.g. vm
 */
export const QuoteFormComponent = memoize((context) => {
	log('QuoteFormComponent', context);

	// Get Values and push into matrix
	let $wordSelectors = $(WORD_SELECTOR_SELECTOR, context),
		wordSelectorValues = extractAllWordSelectorValues($wordSelectors);
	log('wordSelectorValues:', wordSelectorValues);

	// No longer require the original word selectors, as we'll load them in with Vue
	$wordSelectors.remove();

	return Vue.extend({
		props: {
			type: String,
			matrixSync: String,
			matrixSyncNameOverride: false,
		},
		data () {
			let values = Object.assign({}, wordSelectorValues);

			return {
				values,
				matrix: {}
			};
		},
		compiled () {
			$(this.$el).addClass(HAS_VUE);
			this.matrixSync = this.matrix[this.getMatrixName()];
		},
		components: {
			'word-selector': WordSelectorComponent(context)
		},
		methods: {
			setMatrixValue (value, name) {
				this.matrix[this.getMatrixName(name)] = value;
				this.matrixSync = value;
			},

			getMatrixName (name) {
				if (!name) {
					name = this.type;
				}

				return this.matrixSyncNameOverride ? this.matrixSyncNameOverride : name;
			},
		},
		watch: {
			matrixSync (value) {
				this.matrix[this.getMatrixName()] = value;
			}
		},
		events: {
			'matrix-word-selected' (value, name) {
				log('matrix-word-selected event received, value:', value);
				this.setMatrixValue(value, name);
			},
		},
	});
});

export {QuoteFormComponent as default};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ps-quote-form/components/quote-form.js